// if a new comment does not pop up
export const PERSIST_BUBBLE_RANGE = 2;

/*
  Floor:
    it would be best to use whole numbers here, because comment time stamps
    are rounded to the nearest second.
  Max: Minimum size 1 seconds */
export const calculateBucketSize = videoLength =>
  Math.floor(Math.max(videoLength / 28, 1)) || 1;

export const bucketInd = (time, videoLength) => {
  const bucketSize = calculateBucketSize(videoLength);

  return Math.floor(time / bucketSize);
};

function time(a, b) {
  return a.time_stamp - b.time_stamp;
}

export const getBuckets = (comments, videoLength) => {
  comments.sort(time);

  return comments.reduce((buckets, comment) => {
    const bucketId = bucketInd(comment.time_stamp, videoLength);

    if (!(bucketId in buckets)) {
      const bucketSize = calculateBucketSize(videoLength);
      const middleOfBucket = Math.floor(bucketSize * bucketId + bucketSize / 2);

      buckets[bucketId] = {
        commentCount: 0,
        ind: bucketId,
        comments: [],
        middleOfBucket,
      };
    }

    const bucket = buckets[bucketId];

    bucket.commentCount++;
    bucket.comments.push(comment);
    bucket.commentCount += comment.replies ? comment.replies.length : 0;

    if (
      !bucket.latestComment ||
      comment.createdAt > bucket.latestComment.createdAt
    ) {
      bucket.latestComment = comment;
    }

    return buckets;
  }, {});
};
